import { LanguageSwitcher } from '@saas-pages/shared/public/app-shell'
import { LOCALES, useLocale, useT, type Locale } from '@/shared/i18n'

const LABEL: Record<Locale, string> = {
  ru: 'RU',
  en: 'EN',
}

export function LangSwitcher() {
  const t = useT()
  const { locale, setLocale } = useLocale()

  return (
    <LanguageSwitcher
      locales={LOCALES}
      locale={locale}
      onLocaleChange={setLocale}
      labels={LABEL}
      ariaLabel={t.langSwitcher.aria}
    />
  )
}
